module.exports = __webpack_public_path__ + "img/operaciones-en-tramite.f470f0ce.svg";